import { PipesModule } from '@app/pipes/pipes.module';
import { BasicLayoutComponent } from './basic-layout/basic-layout.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { TopNavigComponent } from './top-navig/top-navig.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedModule } from '@app/modules/shared/shared.module';
import { PanierModule } from '../panier/panier.module';
import { HelpycurrencyModule } from '@app/pipes/helpycurrency/helpycurrency.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BsDropdownModule.forRoot(),
    CollapseModule.forRoot(),
    SharedModule,
    PipesModule,
    PanierModule,
    HelpycurrencyModule
  ],
  declarations: [
    BasicLayoutComponent,
    TopNavigComponent,
    FooterComponent
  ],
  exports: [
    BasicLayoutComponent,
    TopNavigComponent,
    FooterComponent,
  ]
})
export class CommonComponentsModule { }
